"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@chakra-ui/react");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * @param {{
 * id: string
 * showControls: boolean,
 * }} props
 */
var VideoYoutube = function VideoYoutube(props) {
  var id = props.id,
      showControls = props.showControls;
  var ref = (0, _react.useRef)(null);
  return __jsx(_react["default"].Fragment, null, __jsx(_react2.Box, {
    w: "100%",
    minW: "320px",
    pb: "56.25%",
    position: "relative"
  }, __jsx(_react2.Box, {
    ref: ref,
    as: "iframe",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    src: "https://www.youtube.com/embed/".concat(id).concat(showControls ? "?controls=1" : "?controls=0"),
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  })));
};

var _default = VideoYoutube;
exports["default"] = _default;